import { render } from "./PieChartButton.vue?vue&type=template&id=6978e2ca&scoped=true"
import script from "./PieChartButton.vue?vue&type=script&lang=js"
export * from "./PieChartButton.vue?vue&type=script&lang=js"

import "./PieChartButton.vue?vue&type=style&index=0&id=6978e2ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6978e2ca"]])

export default __exports__